/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Snackbar,
  Box,
  Grid,
  Dialog,
  InputLabel,
  Paper,
  Avatar,
  Badge,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import MDButton from "components/MDButton";
import VpnKeyOffIcon from "@mui/icons-material/VpnKeyOff";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { JsonTool } from "utils/jsonTools";
import { LinkImage } from "utils/linkImage";
import { API_URL } from "utils/constants";
import dayjs from "dayjs";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const defaultValue = {
  email: null,
  first_name: "",
  last_name: "",
  birth_date: null,
  gender: null,
  address: "",
  profile_pic: null,
  auth2: false,
};

const allowedFileTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml", // image/*
];

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  flexGrow: 1,
}));
const PersonalProfile = ({
  open,
  data,
  onClose,
  onSubmit,
  title,
  validationErrors,
}) => {
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    birth_date: "",
    email: "",
  });
  const [dataState, setDataState] = useState(defaultValue);
  const axiosPrivateInstance = useAxiosPrivate();
  const formRef = useRef(null);
  const fileInput = useRef();
  const [avatarUrl, setAvatarUrl] = useState("");
  const [fileAvatar, setFileAvatar] = useState();
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [values, setValues] = useState({
    showPass: false,
  });
  const [revalues, setReValues] = useState({
    showPass: false,
  });
  const handleImageUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size / (1024 * 1024) > 10) {
        let _err = "Kích thước tệp quá lớn. Tệp upload phải nhỏ hơn 10MB.";
        setErrors({ ...errors, profile_pic: _err });
        return;
      }
      // Kiểm tra định dạng
      const fileTypeIsValid = allowedFileTypes.some(
        (type) => selectedFile.type == type
      );

      if (!fileTypeIsValid) {
        let _err = "Tệp phải có định dạng: .jpeg, .png, .svg, .gif";
        setErrors({ ...errors, profile_pic: _err });
        return; // Dừng xử lý nếu định dạng không hợp lệ
      }
      const urlIamge = URL.createObjectURL(selectedFile);
      setAvatarUrl(urlIamge);
      setFileAvatar(selectedFile);
    }
  };
  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    if (name == "auth2") {
      value = e.target.checked;
    }
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    _data["id"] = data?.id;
    const listFormatDate = ["birth_date"];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? dayjs(dataState?.[field]).format("YYYY-MM-DD")
          : null;
    });
    if (fileAvatar && fileAvatar.name) {
      let json = await JsonTool.convertToBase64(fileAvatar);
      _data["anhdaidien"] = json;
      _data["tenanhdaidien"] = fileAvatar.name;
      _data["edit"] = true;
    } else {
      _data["edit"] = false;
    }
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    if (!fileAvatar?.name) {
      delete _data["profile_pic"];
    }
    // console.log(_data);
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    setErrors(validationErrors);
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setFileAvatar(null);
      if (data?.id) {
        setDataState(data);
        setAvatarUrl(API_URL + data?.profile_pic);
      } else {
        setAvatarUrl(null);
        setDataState(defaultValue);
      }
      setReValues(false);
      setValues(false);
      setErrors([]);
    }
  }, [open]);

  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  const handleRePassVisibilty = () => {
    setReValues({
      ...revalues,
      showPass: !revalues.showPass,
    });
  };

  const handleChangepassword = async (event) => {
    event.preventDefault();
    const form = formRef.current;
    const _data = {};
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      _data[key] = value;
    });
    _data["id"] = data?.id;
    _data["username"] = data?.username;
    if (_data["password"].length == 0) {
      setErrors({
        ...errors,
        password: "Mật khẩu không được trống",
      });
      return;
    }
    if (checkconfirmpassword(_data["password"], _data["repassword"])) {
      setErrors({
        ...errors,
        repassword: "Mật khẩu không khớp",
      });
      return;
    }
    try {
      const response = await axiosPrivateInstance.put(
        "changepassword/" + _data.username,
        { ..._data },
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setAlert({
        alert: true,
        message: "Thay đổi mật khẩu thành công!",
        type: "success",
      });
    } catch (error) {
      console.log(error);
      return;
    }
  };
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };
  return (
    <Dialog open={open} maxWidth={"md"}>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <form ref={formRef} method="post" encType="multipart/form-data">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title ? title : "Thông tin Tài khoản người dùng"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ p: 1 }}>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Paper
              sx={{
                p: 2,
                margin: "auto",
                maxWidth: 800,
                width: 560,
                flexGrow: 1,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "#1A2027" : "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={6}
                  sm
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Grid
                    item
                    sm
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    className="gradient-custom"
                  >
                    <Grid item>
                      <StyledBadge
                        sx={{ textAlign: "center" }}
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        variant="dot"
                      >
                        <Avatar
                          sx={{
                            width: 160,
                            height: 160,
                            textAlign: "center",
                            backgroundColor: "rgb(214, 214, 214)",
                          }}
                          alt="Logo"
                          src={avatarUrl ? avatarUrl : LinkImage.userDefault}
                        />
                      </StyledBadge>
                    </Grid>
                    <Grid item>
                      <MDButton
                        color="primary"
                        size="small"
                        variant="contained"
                        startIcon={<CameraAltIcon />}
                        onClick={() => fileInput.current.click()}
                      >
                        Thay đổi hình đại diện
                      </MDButton>
                      <input
                        ref={fileInput}
                        name="profile_pic"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => handleImageUpload(e)}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    sm
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    className="gradient-custom"
                  >
                    <Grid
                      item
                      xs={12}
                      sx={{ paddingRight: "10px", paddingLeft: "10px" }}
                    >
                      <TextField
                        fullWidth
                        required
                        type={values.showPass ? "text" : "password"}
                        name="password"
                        variant="standard"
                        error={errors ? !!errors.password : false}
                        helperText={errors?.password}
                        label="Mật khẩu"
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            password: "",
                          });
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handlePassVisibilty}
                                aria-label="toggle password"
                                edge="end"
                              >
                                {values.showPass ? (
                                  <VisibilityOffIcon />
                                ) : (
                                  <VisibilityIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{ paddingRight: "10px", paddingLeft: "10px" }}
                    >
                      <TextField
                        fullWidth
                        required
                        type={revalues.showPass ? "text" : "password"}
                        name="repassword"
                        variant="standard"
                        error={errors ? !!errors.repassword : false}
                        helperText={errors?.repassword}
                        label="Xác nhận mật khẩu"
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            repassword: "",
                          });
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleRePassVisibilty}
                                aria-label="toggle password"
                                edge="end"
                              >
                                {revalues.showPass ? (
                                  <VisibilityOffIcon />
                                ) : (
                                  <VisibilityIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="center"
                      container
                      direction="row"
                      alignItems="center"
                    >
                      <MDButton
                        type="submit"
                        color="warning"
                        variant="contained"
                        startIcon={<VpnKeyOffIcon />}
                        size="small"
                        onClick={handleChangepassword}
                      >
                        Thay đổi mật khẩu
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm container>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        name="first_name"
                        variant="standard"
                        error={errors ? !!errors.first_name : false}
                        helperText={errors?.first_name}
                        label="Họ lót"
                        value={dataState.first_name || ""}
                        onChange={handleChangeValueInput("first_name")}
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            first_name: "",
                          });
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        name="last_name"
                        variant="standard"
                        error={errors ? !!errors.last_name : false}
                        helperText={errors?.last_name}
                        label="Tên"
                        value={dataState.last_name || ""}
                        onChange={handleChangeValueInput("last_name")}
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            last_name: "",
                          });
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        name="email"
                        variant="standard"
                        error={errors ? !!errors.email : false}
                        helperText={errors?.email}
                        label="Email"
                        value={dataState.email || ""}
                        onChange={handleChangeValueInput("email")}
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            email: "",
                          });
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        fullWidth
                        type="date"
                        required
                        name="birth_date"
                        variant="standard"
                        error={errors ? !!errors.birth_date : false}
                        helperText={errors?.birth_date}
                        label="Ngày sinh"
                        value={dataState.birth_date || ""}
                        onChange={handleChangeValueInput("birth_date")}
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            birth_date: "",
                          });
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <FormControl fullWidth size="small">
                        <InputLabel id="label-gioitinh">Giới tính</InputLabel>
                        <Select
                          required
                          variant="standard"
                          sx={{ padding: "0.7rem" }}
                          labelId="label-gioitinh"
                          value={dataState.gender || "M"}
                          onChange={handleChangeValueInput("gender")}
                          label="Giới tính"
                          name="gender"
                        >
                          <MenuItem key="M" value="M">
                            Nam
                          </MenuItem>
                          <MenuItem key="F" value="F">
                            Nữ
                          </MenuItem>
                          <MenuItem key="O" value="O">
                            Khác
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <TextField
                        fullWidth
                        name="address"
                        variant="standard"
                        error={errors ? !!errors.address : false}
                        helperText={errors?.address}
                        label="Địa chỉ"
                        value={dataState.address || ""}
                        onChange={handleChangeValueInput("address")}
                        onFocus={() => {
                          setErrors({
                            ...errors,
                            address: "",
                          });
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={dataState.auth2}
                              onChange={handleChangeValueInput("auth2")}
                            />
                          }
                          label="Xác thực 2 lớp"
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item>
                      <Button
                        type="submit"
                        variant="contained"
                        startIcon={<SaveIcon />}
                        size="small"
                        onClick={onSubmitForm}
                        sx={{ color: "#ffffff", float: "right" }}
                      >
                        Lưu thay đổi thông tin
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </DialogContent>
      </form>
    </Dialog>
  );
};

const validateRequired = (value) => !!value.length;

function validateOBJ(user) {
  return {
    first_name: !validateRequired(user.first_name)
      ? "Họ lót không được trống"
      : "",
    last_name: !validateRequired(user.last_name) ? "Tên không được trống" : "",
    email: !validateRequired(user.email)
      ? "Email không được trống"
      : validateEmail(user.email)
      ? "Định dạng Email không đúng"
      : "",
    birth_date: !validateRequired(user.birth_date)
      ? "Ngày sinh không được trống"
      : "",
  };
}
const validateEmail = (value, name) => {
  let result = false;
  if (value && JsonTool.validateEmail(value)) {
    result = true;
  }
  return result;
};
const checkconfirmpassword = (value, value1) => {
  let valid = false;
  if (value !== value1) {
    valid = true;
  }
  return valid;
};

export default PersonalProfile;
